/* eslint-disable */
import gsap from "gsap";
import LazyLoad from "vanilla-lazyload";
import Flickity from "flickity";
import inView from "in-view";
import Isotope from "isotope-layout";
import {} from "isotope-packery";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
const HTML = document.querySelector('html');

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
        window.dispatchEvent(new Event("scroll"));
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });


    /** Move header */
    const header = document.querySelector(".main-header");
    if (header) {
      let prevY = 0;
      window.addEventListener("scroll", () => {
        prevY = window.scrollY;

        const darkSections = document.querySelectorAll("section.from-red-500, section.bg-red-500");

        if (darkSections) {
          for (const section of darkSections) {
            const bound = section.getBoundingClientRect();
            if (
              bound.y <= header.offsetHeight / 2 &&
              bound.bottom > header.offsetHeight / 2
            ) {
              HTML.classList.add("header-black");
              break;
            } else {
              HTML.classList.remove("header-black");
            }
          }
        }
      });

      window.dispatchEvent(new Event("scroll"));
    }

    /** Toggle menu */
    const toggleMenus = document.querySelectorAll('.toggle-menu')
    if( toggleMenus ) {
      toggleMenus.forEach(menu => {
        menu.addEventListener('click', e => {
          e.preventDefault();
          HTML.classList.toggle('open-menu')
        })
      })
    }

    this.logoAnim();
    this.scrollAnchor();
    this.isotopeGrid();
    this.nav();
    this.carousel();
    this.carouselDragnDrop();
    this.parallax();
    this.videoPlayer();
    this.scrollFix();
    this.marquee();
    this.contact();
    this.inViewport();
  }

  logoAnim() {
    const tlLogo = gsap.timeline({ paused: true });
    const logo = document.querySelector(".main-header .icon--logo");
    tlLogo
      .to(logo.querySelectorAll(".chars > *"), {
        duration: 0.1,
        autoAlpha: 0,
        stagger: {
          from: "end",
          each: 0.01,
        },
      })
      .fromTo(
        logo.querySelector(".rect-gradient"),
        {
          scale: 0,
          autoAlpha: 1,
          transformOrigin: "50% 50%",
        },
        {
          duration: 0.4,
          ease: "expo.out",
          scale: 1,
          transformOrigin: "50% 50%",
        },
        "finish"
      )
      .to(
        logo.querySelectorAll(".frago > *"),
        {
          duration: 0.4,
          ease: "expo.out",
          fill: "#FFF",
        },
        "finish"
      );

    let oldScrollY = 0;
    window.addEventListener("scroll", () => {
      if (oldScrollY > window.scrollY && window.scrollY < 10) {
        // Up
        tlLogo.pause().reverse();
      } else if (oldScrollY > 10) {
        // Down
        tlLogo.pause().play();
      }

      oldScrollY = window.scrollY;
    });
  }
  
  isotopeGrid() {
    const elts = document.querySelectorAll('.isotope-grid');

    if( elts ) {
      elts.forEach(el => {
        
        const iso = new Isotope(el, {
          itemSelector: ".item",
          layoutMode: "packery",
        });
      })
    }
  }

  scrollFix() {
    const elts = document.querySelectorAll('.sticky-elts')
    if( elts ) {
      elts.forEach(el => {
        let tl;
        const items = el.querySelectorAll('.item');

        window.addEventListener('resize', () => {
          this.throttle(() => {
            killAll();
            initSticky();
          }, 250)
        })


        function initSticky() {
          const hEl = el.offsetHeight;

          if( items ) {

            // const headers = el.querySelectorAll('.header');
            // const contents = el.querySelectorAll('.content');
            // const intro = el.querySelector('.intro');


            let hContainer = 0 ;
            items.forEach((item, i) => {
              gsap.set(item, {
                position: 'absolute',
                top: 0,
              })
              if( i < items.length - 1 ) {
                // hContainer += headers[i].offsetHeight;
              } else {
                hContainer += item.offsetHeight;
              }

              // if( i < items.length - 1 ) {
              //   hContainer += contents[i].offsetHeight
              // }
            })
            gsap.set( el , { height : hContainer })

            tl = gsap.timeline();

            let hPrev = 0;
            let hHeader = 0;
            items.forEach((item, i) => {              

              if(i > 0){
                const prev = items[i-1];
                hPrev += parseFloat(prev.offsetHeight) - 20;
                // hHeader += parseFloat(prev.querySelector('.header').offsetHeight);
                gsap.set(item, {y:hPrev})
                tl.to(item, {y:0, duration:i*0.5, ease:"none"},'start')
               
              } else {
                
              }
            })

            ScrollTrigger.create({
              trigger:el,
              start:"top top",
              end:`+=${hEl}px bottom`,
              scrub:0.1,
              pin: true,
              animation:tl,
              // markers:true
            })
          }
        }

        function killAll() {
          const scrolls = ScrollTrigger.getAll();
          if( scrolls ) {
            for( let i = 0; i < scrolls.length; i++) {
              scrolls[i].kill(true);
            }
          }

          tl.kill(true);
          gsap.set(el, { clearProps: 'all' })

          if( items ) {

            items.forEach((item) => {
              gsap.set(item, { clearProps: 'all' })
            })
          }
        }

        initSticky()
        
      })
    }
  }

  marquee() {
    const marquees = document.querySelectorAll(".marquee .line");
    if (marquees) {
      marquees.forEach((el) => {
        const orgin = el.dataset.speed
          ? Number.parseFloat(el.dataset.speed)
          : 0.65;
        let pas = el.dataset.speed ? Number.parseFloat(el.dataset.speed) : 0.65;

        window.addEventListener("wheel", (e) => {
          pas = (e.deltaY < 0 ? -1 : 1) * orgin;
        });
        const flkty = new Flickity(el, {
          cellAlign: "center",
          freeScroll: true,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          draggable: false,
        });

        flkty.request = 0;

        function play() {
          flkty.x -= Number.parseFloat(el.dataset.dir) * pas;
          flkty.settle(flkty.x);
          flkty.request = window.requestAnimationFrame(play);
        }

        el.addEventListener("inview", (e) => {
          play();
        });
        el.addEventListener("outview", (e) => {
          window.cancelAnimationFrame(flkty.request);
        });
      });
    }
  }
  
  async contact() {
    const forms = document.querySelectorAll('.form-contact');

    if( forms ) {
      forms.forEach(form => {
        form.addEventListener('submit', async(e) => {
          e.preventDefault();
          const oldMsg = form.querySelectorAll('.form-msg');
          if( oldMsg ) {
            oldMsg.forEach(m => m.remove())
          }

          form.classList.add('loaded')

          const formData = new FormData(form);
          formData.append('timestamp', (new Date()).getTime())

          const url = 'https://w5uwcow2atojphomw5unlprzym0cyfgf.lambda-url.eu-west-1.on.aws/';//"https://2awatfb27rkiuz6ep7rpb4z7t40rmsuy.lambda-url.eu-west-1.on.aws/"
          try {
            const response = await fetch(url, {
              method: 'POST',
              headers: {
                  'content-type': 'application/json'
              },
              // body: JSON.stringify(Object.fromEntries(formData.entries())),
              body : JSON.stringify({
                firstname: e.target.firstname.value,
                lastname: e.target.lastname.value,
                email: e.target.email.value,
                phone: e.target.phone.value,
                company: e.target.company.value,
                message: e.target.message.value,
                timestamp: +new Date(),
              })
            });
            const output = await response.json();
            form.classList.remove('loaded')

            let m = optMsg.form_error;
            if( output && output.success ) {
              form.reset();
              m = optMsg.form_success;
            } else {
              console.error(output);
            }
            
            const msgEl = document.createElement('div');
            msgEl.innerHTML = m;
            msgEl.classList.add('form-msg');
            
            form.prepend(msgEl);
          } catch (e) {
            console.error(e);
            form.classList.remove('loaded')
            
            const msgEl = document.createElement('div');
            msgEl.classList.add('form-msg');
            msgEl.innerHTML = optMsg.form_error;
            form.prepend(msgEl);
          }

          return false;
        })
      })
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible), [data-scroll]")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" &&
            elt.dataset.autoplay != "" &&
            elt.dataset.autoplay != undefined) ||
          (video &&
            video.dataset.autoplay != "" &&
            video.dataset.autoplay != undefined)
        ) {
          const v = video || elt;
          v.play();
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" &&
            elt.dataset.autoplay != "" &&
            elt.dataset.autoplay != undefined) ||
          (video &&
            video.dataset.autoplay != "" &&
            video.dataset.autoplay != undefined)
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }

  scrollAnchor() {
    // Detect if a link's href goes to the current page
    function getSamePageAnchor(link) {
      if (
        link.protocol !== window.location.protocol ||
        link.host !== window.location.host ||
        link.pathname !== window.location.pathname ||
        link.search !== window.location.search
      ) {
        return false;
      }

      return link.hash;
    }

    // Scroll to a given hash, preventing the event given if there is one
    function scrollToHash(hash, e) {
      const elem = hash ? document.querySelector(hash) : false;
      if (elem) {
        if (e) e.preventDefault();
        gsap.to(window, { scrollTo: elem, ease: "expo.out", duration: 0.8 });
      }
    }

    // If a link's href is within the current page, scroll to it instead
    document.querySelectorAll("a[href]").forEach((a) => {
      a.addEventListener("click", (e) => {
        scrollToHash(getSamePageAnchor(a), e);
      });
    });

    // Scroll to the element in the URL's hash on load
    scrollToHash(window.location.hash);
  }

  nav() {
    const navs = document.querySelectorAll(".main-nav");

    if (navs) {
      navs.forEach((nav) => {
        const links = nav.querySelectorAll(".menu-item a");
        const cursor = nav.querySelector(".cursor");
        let current = -1;
        let oldScrollY = 0;

        if (links && links.length > 0 && cursor) {
          function activeCursor(link) {
            const boundParent = nav.getBoundingClientRect();
            const boundLink = link.getBoundingClientRect();

            gsap.to(cursor, {
              duration: 0.3,
              width: boundLink.width,
              x: boundLink.x - boundParent.x,
              ease: "none",
            });

            if (links[current]) links[current].classList.remove("active");
            link.classList.add("active");
          }

          const active = nav.querySelector('.current-menu-item, .current_page_parent');
          if( active ) {
            activeCursor(active)
          }

          window.addEventListener("scroll", (e) => {
            for (let i = 0; i < links.length; i++) {
              const index = links.length - i - 1;
              const link = links[index];
              let href = link.getAttribute("href").replace(siteURL, '');
              href = href.replaceAll(currentLang, '')

              if( href != "#" && href != '/' && href != '')
              {

                const target = document.querySelector(
                  href.replaceAll("/", "")
                );
  
                if (target) {
                  const bound = target.getBoundingClientRect();
                  if (bound.top - window.innerHeight * 0.1 <= 0) {
                    activeCursor(link)
                    current = index;
  
                    break;
                  }
                }
              }
            }

            oldScrollY = window.scrollY;
          });
        }
      });
    }
  }

  carousel() {
    const carousels = document.querySelectorAll(".carousel");

    if (carousels)
      carousels.forEach((carousel) => {
        function checkIfEnough(c, f) {
          if (c.classList.contains("carousel-imgs") && f.cells.length > 0) {
            const w = f.size.width;
            const wCell = f.cells[0].element.offsetWidth;
            const nbVisibleCells = Math.round(w / wCell);

            if (nbVisibleCells >= f.cells.length) {
              f.options.draggable = false;
              c.classList.add("no-slide");
              f.updateDraggable();
            } else {
              f.options.draggable = true;
              f.updateDraggable();
              c.classList.remove("no-slide");
            }
          }
        }

        const flkty = new Flickity(carousel, {
          cellAlign: "left",
          contain: true,
          on: {
            ready() {
              checkIfEnough(carousel, this);
            },
            resize() {
              checkIfEnough(carousel, this);
            },
            select(index) {
              if (carousel.classList.contains("carousel-imgs")) {
                const w = this.size.width;
                const wCell = this.cells[0].element.offsetWidth;
                const nbVisibleCells = Math.round(w / wCell);

                this.cells.forEach((cell, i) => {
                  if (i >= index && i < index + nbVisibleCells) {
                    cell.element.classList.add("is-cell-visible");
                  } else {
                    cell.element.classList.remove("is-cell-visible");
                  }
                });

                if (index == 0)
                  this.prevButton.element.classList.add("disabled");
                else this.prevButton.element.classList.remove("disabled");

                if (index + nbVisibleCells >= this.cells.length)
                  this.nextButton.element.classList.add("disabled");
                else this.nextButton.element.classList.remove("disabled");
              }
            },
          },
        });
        flkty.cells.forEach( function( cell ) {
          // cell.element.style.height = '100%'
        })
      });
  }

  carouselDragnDrop() {
    const carousels = document.querySelectorAll(".carousel-dragndrop");

    if (carousels)
      carousels.forEach((carousel) => {

        const flkty = new Flickity(carousel, {
          cellAlign: "left",
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          on: {
          },
        });
        flkty.cells.forEach( function( cell ) {
          // cell.element.style.height = '100%'
        })
      });
  }

  videoPlayer() {
    const players = document.querySelectorAll(".js-player");

    if (players) {
      players.forEach((player) => {
        const video = player.querySelector("video:not(.preview)");

        if (video) {
          /** BUILD CONTROLS */
          const controls = document.createElement("div");
          controls.classList.add("controls");
          player.append(controls);

          const playPause = document.createElement("a");
          playPause.classList.add("play-pause");
          controls.append(playPause);

          const progress = document.createElement("div");
          progress.classList.add("progress");
          controls.append(progress);
          const bar = document.createElement("div");
          bar.classList.add("bar");
          progress.append(bar);

          const sound = document.createElement("a");
          sound.classList.add("sound");
          controls.append(sound);

          const fullscreen = document.createElement("a");
          fullscreen.classList.add("fullscreen");
          controls.append(fullscreen);

          const btnPlay = player.querySelector("[data-play]");
          if (btnPlay) {
            btnPlay.addEventListener("click", (e) => {
              e.preventDefault();
              video.play();
            });
          }
          const trigger = player.querySelector("[data-trigger-player]");
          if (trigger) {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              video.play();
            });
          }

          /** EVENTS LISTENER */
          // CLICK
          playPause.addEventListener("click", (e) => {
            e.preventDefault();
            if (video.paused) video.play();
            else video.pause();
          });

          // PROGRESS CLICK
          progress.addEventListener("click", (e) => {
            const bounding = progress.getBoundingClientRect();
            const percent = (e.clientX - bounding.x) / bounding.width;

            video.currentTime = percent * video.duration;
          });

          // CLICK
          video.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (video.paused) video.play();
            else video.pause();
          });

          // FULLSCREEN
          fullscreen.addEventListener("click", (e) => {
            e.preventDefault();
            if (!video.fullscreenElement) {
              video.requestFullscreen();
            } else if (video.exitFullscreen) {
              video.exitFullscreen();
            }
          });

          // SOUND
          sound.addEventListener("click", (e) => {
            e.preventDefault();
            if (!video.muted) {
              video.muted = true;
              player.classList.add("soundoff");
            } else {
              video.muted = false;
              player.classList.remove("soundoff");
            }
          });

          video.addEventListener("mouseenter", () => {
            player.classList.add("is-mouseenter");
          });
          video.addEventListener("mouseleave", () => {
            player.classList.remove("is-mouseenter");
          });

          // IS PLAYING
          video.addEventListener("playing", () => {
            player.classList.add("is-playing");
          });
          // IS PAUSE
          video.addEventListener("pause", () => {
            player.classList.remove("is-playing");
          });

          // TIMEUPDATE
          video.addEventListener("timeupdate", () => {
            gsap.set(bar, {
              width: `${(video.currentTime / video.duration) * 100}%`,
            });
          });
        }
      });
    }
  }

  parallax() {
    const elts = document.querySelectorAll(".js-parallax");

    if (elts) {
      elts.forEach((el) => {
        gsap.to(el, {
          scrollTrigger: {
            trigger: el,
            scrub: true,
          },
          y: (i, target) => {
            return -ScrollTrigger.maxScroll(window) * target.dataset.speed;
          },
          x: (i, target) => {
            if (target.dataset.x && target.dataset.x != "") {
              return -ScrollTrigger.maxScroll(window) * target.dataset.speed;
            }
          },
          ease: "power1.out",
        });
      });
    }
  }

  throttle(func, delay){
    if (timerThrottle) {
      window.clearTimeout(timerThrottle);
    }
    timerThrottle = window.setTimeout(func, delay);
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
  window.dispatchEvent(new Event("scroll"));
});
